import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type UpdateDivisionMutationVariables = Types.Exact<{
  input: Types.UpdateDivisionCommand;
}>;


export type UpdateDivisionMutation = { __typename?: 'MutationModel', divisions: { __typename?: 'DivisionMutationModel', update: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const UpdateDivisionDocument = gql`
    mutation UpdateDivision($input: UpdateDivisionCommand!) {
  divisions {
    update(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type UpdateDivisionMutationFn = Apollo.MutationFunction<UpdateDivisionMutation, UpdateDivisionMutationVariables>;

/**
 * __useUpdateDivisionMutation__
 *
 * To run a mutation, you first call `useUpdateDivisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDivisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDivisionMutation, { data, loading, error }] = useUpdateDivisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDivisionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDivisionMutation, UpdateDivisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDivisionMutation, UpdateDivisionMutationVariables>(UpdateDivisionDocument, options);
      }
export type UpdateDivisionMutationHookResult = ReturnType<typeof useUpdateDivisionMutation>;
export type UpdateDivisionMutationResult = Apollo.MutationResult<UpdateDivisionMutation>;
export type UpdateDivisionMutationOptions = Apollo.BaseMutationOptions<UpdateDivisionMutation, UpdateDivisionMutationVariables>;